import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerTwo from "../components/DashBoardLayerTwo";

const HomePageTwo = () => {
  return (
    <>
      <Breadcrumb title="Overview" />
      <DashBoardLayerTwo />
    </>
  );
};

export default HomePageTwo;